"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _reactTether = _interopRequireDefault(require("react-tether"));

var _Dropdown = _interopRequireDefault(require("react-bootstrap/lib/Dropdown"));

var _splitComponentProps3 = _interopRequireDefault(require("react-bootstrap/lib/utils/splitComponentProps"));

var _Objects = require("@phg/stilo-utils/Objects");

var _ThemeProvider = require("../ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _Menu$propTypes;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Menu = function Menu(_ref) {
  var classes = _ref.classes,
      menuRef = _ref.menuRef,
      style = _ref.style,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["classes", "menuRef", "style"]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.Dropdown, " stilo-bootstrap open btn-group"),
    style: {
      display: 'block',
      position: 'initial',
      width: 'initial',
      height: 'initial'
    }
  }, /*#__PURE__*/React.createElement(_Dropdown["default"].Menu, (0, _extends2["default"])({}, props, {
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: 'block',
      "float": 'none',
      overflowY: 'scroll'
    }),
    open: true,
    ref: menuRef
  })));
};

Menu.propTypes = (_Menu$propTypes = {
  "menuRef": _propTypes["default"].func.isRequired,
  classes: _propTypes["default"].shape({
    Dropdown: _propTypes["default"].string.isRequired
  }).isRequired
}, (0, _defineProperty2["default"])(_Menu$propTypes, "menuRef", _propTypes["default"].func.isRequired), (0, _defineProperty2["default"])(_Menu$propTypes, "style", _propTypes["default"].object), _Menu$propTypes);
var StyledMenu = (0, _ThemeProvider.withStyles)(_style["default"])(Menu);

var adjustNodeSide = function adjustNodeSide(node, padding) {
  var rect = node.getBoundingClientRect();
  node.style.maxHeight = window.innerHeight - rect.top - padding + 'px';
};

var TetheredMenu = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(TetheredMenu, _React$Component);

  var _super = _createSuper(TetheredMenu);

  function TetheredMenu() {
    var _this;

    (0, _classCallCheck2["default"])(this, TetheredMenu);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "menu", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "updateDimensions", function () {
      if (_this.menu) {
        // eslint-disable-next-line react/no-find-dom-node,flowtype/no-weak-types
        adjustNodeSide(_reactDom["default"].findDOMNode(_this.menu), _this.props.windowPadding);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "focusNext", function () {
      //console.log('TetheredMenu, focusNext', this.menu);
      if (_this.menu) {
        _this.menu.focusNext();
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "handleMenuRef", function (e) {
      _this.menu = e;
    });
    return _this;
  }

  (0, _createClass2["default"])(TetheredMenu, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateDimensions();
      window.addEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateDimensions();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.props.open) {
        return null;
      }

      var attachment = this.props.pullRight ? 'right' : 'left';
      return /*#__PURE__*/React.createElement(_reactTether["default"], {
        attachment: "bottom ".concat(attachment),
        targetAttachment: "bottom ".concat(attachment),
        offset: "-32px 0",
        classes: {
          element: 'tether-dropdown'
        }
      }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement(StyledMenu, (0, _extends2["default"])({}, (0, _Objects.filterProps)(['windowPadding'])(this.props), {
        menuRef: this.handleMenuRef
      })));
    }
  }]);
  return TetheredMenu;
}(React.Component);

(0, _defineProperty2["default"])(TetheredMenu, "propTypes", _objectSpread(_objectSpread({}, _Dropdown["default"].Menu.propTypes), {}, {
  windowPadding: _propTypes["default"].number
}));
(0, _defineProperty2["default"])(TetheredMenu, "defaultProps", {
  bsRole: 'menu',
  windowPadding: 20
});

var DropdownButtonTethered = /*#__PURE__*/function (_React$Component2) {
  (0, _inherits2["default"])(DropdownButtonTethered, _React$Component2);

  var _super2 = _createSuper(DropdownButtonTethered);

  function DropdownButtonTethered() {
    var _this2;

    (0, _classCallCheck2["default"])(this, DropdownButtonTethered);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this2 = _super2.call.apply(_super2, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "target", null);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this2), "handleTargetRef", function (e) {
      _this2.target = e;
    });
    return _this2;
  }

  (0, _createClass2["default"])(DropdownButtonTethered, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          bsSize = _this$props.bsSize,
          bsStyle = _this$props.bsStyle,
          title = _this$props.title,
          children = _this$props.children,
          props = (0, _objectWithoutProperties2["default"])(_this$props, ["bsSize", "bsStyle", "title", "children"]);

      var _splitComponentProps = (0, _splitComponentProps3["default"])(props, _Dropdown["default"].ControlledComponent),
          _splitComponentProps2 = (0, _slicedToArray2["default"])(_splitComponentProps, 2),
          dropdownProps = _splitComponentProps2[0],
          toggleProps = _splitComponentProps2[1];

      return /*#__PURE__*/React.createElement(_Dropdown["default"], (0, _extends2["default"])({}, dropdownProps, {
        bsSize: bsSize,
        bsStyle: bsStyle
      }), /*#__PURE__*/React.createElement(_Dropdown["default"].Toggle, (0, _extends2["default"])({}, toggleProps, {
        bsSize: bsSize,
        bsStyle: bsStyle,
        ref: this.handleTargetRef
      }), title), /*#__PURE__*/React.createElement(TetheredMenu, {
        pullRight: props.pullRight
      }, children));
    }
  }]);
  return DropdownButtonTethered;
}(React.Component);

(0, _defineProperty2["default"])(DropdownButtonTethered, "propTypes", _objectSpread(_objectSpread({}, _Dropdown["default"].propTypes), {}, {
  // Toggle props.
  bsStyle: _propTypes["default"].string,
  bsSize: _propTypes["default"].string,
  title: _propTypes["default"].node.isRequired,
  noCaret: _propTypes["default"].bool,
  children: _propTypes["default"].node
}));
var _default = DropdownButtonTethered;
exports["default"] = _default;
//# sourceMappingURL=dropdown-button-tethered.js.map